<template>
  <!-- App.vue -->
  <v-app>
    <v-navigation-drawer v-model="drawer" app clipped-left temporary>
      <v-list-item link to="/">
        <v-list-item-avatar>
          <v-img src="@/assets/ObiPetsLogo.svg"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>ObiPets</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item link to="adminDash">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Inicio</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link>
          <v-list-item-icon>
            <v-icon>mdi-qrcode-plus</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title @click.stop="dialog = !dialog">
              Generar Codigos
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/dashboard/veterinarias">
          <v-list-item-icon>
            <v-icon>mdi-store</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title> Agregar Vetinarias </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template>
        <div>
          <v-btn block @click="_logout"> Cerrar sesión </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <!-- Sizes your content based upon application components -->
    <v-content class="maindash">
      <!-- Provides the application the proper gutter -->
      <v-container fluid>
        <div class="text-center mb-8">
          <v-btn @click.stop="drawer = !drawer">
            <v-icon>{{ "mdi-menu" }}</v-icon>
          </v-btn>
        </div>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12 ml-5" style="margin-top: 80px">
              <v-card-text>
                <form>
                  <form-wrapper :validator="$v.form">
                    <div style="margin-bottom: 20px">
                      <form-summary />
                    </div>
                    <form-group name="storeName">
                      <template slot-scope="{ attrs }">
                        <v-text-field
                          type="text"
                          outlined
                          v-bind="attrs"
                          append-icon="mdi-store"
                          v-model="form.storeName"
                          hint="4 caracteres requeridos"
                          label="Nombre"
                          @input="$v.form.storeName.$touch()"
                        />
                      </template>
                    </form-group>

                    <form-group name="addrress">
                      <template slot-scope="{ attrs }">
                        <v-textarea
                          type="text"
                          outlined
                          v-bind="attrs"
                          append-icon="mdi-map-marker"
                          v-model="form.addrress"
                          hint="4 caracteres requeridos"
                          label="Direccion"
                          @input="$v.form.addrress.$touch()"
                        />
                      </template>
                    </form-group>
                    <form-group name="phoneNumber">
                      <template slot-scope="{ attrs }">
                        <v-text-field
                          autocomplete="off"
                          type="text"
                          outlined
                          v-bind="attrs"
                          v-model="form.phoneNumber"
                          append-icon="mdi-phoneNumber"
                          label="Telefono"
                          @input="$v.form.phoneNumber.$touch()"
                        />
                      </template>
                    </form-group>
                    <form-group name="active">
                      <template slot-scope="{ attrs }">
                        <v-container fluid>
                          <h4>Habilitar</h4>
                          <v-radio-group
                            row
                            v-model="form.is_active"
                            :mandatory="false"
                            v-bind="attrs"
                            @input="$v.form.is_active.$touch()"
                          >
                            <v-radio label="Si" value="si"></v-radio>
                            <v-radio label="No" value="no"></v-radio>
                          </v-radio-group>
                        </v-container>
                      </template>
                    </form-group>
                    <form-group name="Image">
                      <v-btn
                        @click="pickFile"
                        color="primary"
                        rounded
                        depressed
                        style="text-transform: none"
                        class="mb-5"
                      >
                        Añadir logo
                        <v-icon>mdi-camera</v-icon>
                      </v-btn>
                      <!-- <v-file-input
                        class="d-none"  
                        :success="form.image == null ? false : true"
                        v-on:keyup="keymonitor('photo')"
                        id="photo"
                        ref="photo"
                        outlined
                        v-model="form.image"
                        accept="image/*"
                        append-icon="mdi-camera"
                        prepend-icon
                        label="Retrato"
                      />-->
                      <input
                        ref="photo"
                        class="d-none"
                        type="file"
                        accept="image/*"
                        @change="onFileChanged"
                      />
                      <!-- Codigo actualizacion de info -->
                      <div class="pictute-actual-container mt-5">
                        <v-img
                          class="img-actual"
                          :src="actualPicture"
                          contain
                        />
                      </div>
                      <!-- End Codigo actualizacion de info -->
                    </form-group>
                  </form-wrapper>
                  <p class="typo__p" v-if="submitStatus === 'OK'">
                    ¡La veterinaria se ha registrado!
                  </p>
                  <p class="typo__p" v-if="submitStatus === 'ERROR'">
                    Por favor, corrija los campos.
                  </p>
                  <p class="typo__p" v-if="submitStatus === 'PENDING'">
                    Enviando...
                  </p>
                </form>
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  v-if="this.$route.params.id"
                  color="#9ccc3c"
                  @click.prevent="submitModifyData"
                  style="text-transform:none; color:#fff;"
                  :disabled="$v.$invalid"
                >Modificar datos</v-btn>
                <v-btn
                  v-else
                  style="text-transform: none"
                  color="#9ccc3c"
                  @click.prevent="submit"
                  :disabled="this.$v.$invalid"
                >
                  <span style="color: #fff">Agregar</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-container>
              <v-row align="center" justify="center">
                <v-col>
                  <v-form>
                    <form-wrapper :validator="$v.form">
                      <div style="margin-bottom: 20px">
                        <form-summary />
                      </div>
                      <form-group name="numcode">
                        <template slot-scope="{ attrs }">
                          <v-text-field
                            outlined
                            v-bind="attrs"
                            v-model="form.numcode"
                            append-icon="mdi-qrcode-plus"
                            label="Numero de codigos"
                            @input="$v.form.numcode.$touch()"
                          />
                        </template>
                      </form-group>
                    </form-wrapper>
                  </v-form>
                </v-col>
                <v-card-text>
                  <p>No mas de 100 códigos por archivo</p>
                </v-card-text>
                <v-card-actions>
                  <v-btn :disabled="$v.$invalid" @click.prevent="createCodes">
                    Crear
                    <v-icon> mdi-qrcode-plus </v-icon>
                  </v-btn>
                  <v-btn @click.stop="dialog = !dialog"> Cancelar </v-btn>
                </v-card-actions>
              </v-row>
            </v-container>
          </v-card>
        </v-dialog>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import { numeric, required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
export default {
  created() {},
  mounted(){
    if (this.$route.params.id) {
      this.getStores().then((res) => {
        this.stores = res.map((item) => {
          return item;
        });
        this.setData(this.stores);
      });
    }
  },
  data() {
    return {
      submitStatus: null,
      actualPicture: "",
      per_year: "",
      per_month: "",
      months: [],
      years: [],
      page: 1,
      created: "",
      actualId: "",
      dataForExcel: [],
      dialog: false,
      form: {
        storeName: "",
        addrress: "",
        phoneNumber: "",
        image: null,
        urlLogo: "",
        is_active:null
      },
      documents: [],
      drawer: null,
    };
  },
  validations: {
    form: {
      storeName: { required },
      addrress: { required },
      phoneNumber: { required, numeric },
    },
  },
  methods: {
    ...mapActions("auth", { logout: "logout" }),
    ...mapActions("admin", {
      createCode: "createCode",
      getStores: "getStores",
      saveStore: "saveStore",
      modifyStoreData:"modifyStoreData",
      getData4excel: "getData4excel",
    }),
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";
        this.saveStore(this.getformData())
          .then(() => {
             this.$router.push({
              name: "adminDash",
            });
          })
          .catch((err) => {
            alert({ err });
          });
      }
    },
    setData(stores) {
      for (let key in stores) {
        if (this.$route.params.id == stores[key].id) {
          var location = "http://localhost:8000"+stores[key].image;
          this.actualPicture = location;
          delete stores[key].image;
          this.form = stores[key];
        }
      }
    },
    createCodes() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.error("Revise datos");
      } else {
        let codes = {
          quantityCodes: this.form.numcode,
        };
        this.dialog = false;
        this.createCode(codes)
          .then((data) => {
            this.getPetsCodeFiles();
            window.open(
              "https://www.obipets.com.mx" + data.data.file,
              "_blank"
            );
            this.form.numcode = "";
          })
          .catch(() => {});
      }
    },
    submitModifyData() {
      if (this.form.image == null) {
        this.$delete(this.form, "image");
        this.modifyStoreDataPatch();
      } else {
        this.modifyStoreDataPatch();
      }
    },
    modifyStoreDataPatch() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        let formData = this.getformData();
        let id = this.$route.params.id;
        this.modifyStoreData({ formData, id })
          .then(() => {
            this.submitStatus = "OK";
            this.$router.push({
              name: "adminDash",
            });
          })
          .catch((err) => {
            alert({ err });
          });
      }
    },
    onFileChanged(e) {
      this.form.image = e.target.files[0];
      const input = this.$refs.photo;
      const files = input.files;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.actualPicture = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
      // do something
    },
    pickFile() {
      this.$refs.photo.click();
    },
    getformData() {
      let formData = new FormData();
      for (let key in this.form) {
        // noinspection JSUnfilteredForInLoop
        formData.append(key, this.form[key]);
      }
      return formData;
    },
    _logout() {
      this.logout();
      this.$router
        .push({
          name: "login",
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.v-data-table {
  .v-data-footer {
    .v-data-footer__select {
      display: none;
    }
  }
}
.main-table td {
  text-align: center;
}
.maindash {
  background-image: url("../../assets/img/backgrounds/fondoblanco.png");
  background-size: cover;
}
</style>
